import React, { useState, useRef } from 'react';
import styles from './imageUpload.module.scss'; // import styles

interface ImageUploaderProps {
  onImageSelect: (file: File | null, base64: string | null) => void;
  initialPreview?: string | null;
}

const ImageUploader = ({ onImageSelect, initialPreview }: ImageUploaderProps) => {
  const [preview, setPreview] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    if (initialPreview) {
      setPreview(initialPreview);
    }
  }, [initialPreview]);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result as string;
        setPreview(base64String);
        onImageSelect(file, base64String);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleContainerClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div className={styles.uploaderContainer} onClick={handleContainerClick}>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept="image/png,image/jpeg,image/webp,image/svg+xml"
        className={styles.hiddenInput}
      />

      {preview ? (
        <img src={preview} className={styles.previewImage} alt="Preview" />
      ) : (
        <>
          <div className={styles.plus}>+</div>
          <p className={styles.text}>Upload Image</p>
        </>
      )}
    </div>
  );
};

export default ImageUploader;
